import { Modal, inputCls, btnPrimary } from "../bits";

export function CoordEditModal({ open, mode, schoolName, onClose, form, setForm, busy, onSave }) {
  const isAssign = mode === "assign";
  return (
    <Modal open={open} onClose={onClose}
      title={`${isAssign ? "تعيين منسق" : "منسق"}: ${schoolName || ""}`} testid="coord-edit-modal">
      <div className="space-y-3">
        <div data-testid="coord-modal-hint" className="text-[11px] leading-relaxed rounded-xl bg-turq-100/60 dark:bg-surface2 border border-turq-300/50 dark:border-brd text-turq-900 dark:text-turq-300 p-2.5">
          {isAssign
            ? "أدخل بريد حساب المنسق الموجود مسبقاً — الحفظ يربطه بالمدرسة ويُحدِّث حساب دخوله فوراً، ويدخل من بوابة «منسق التطوع» بالبريد أو الجوال. إن لم يكن له حساب، أنشئه أولاً من صفحة المنسقين."
            : "هذه بيانات دخول المنسق — الحفظ يُحدِّث حساب دخوله فوراً، ويدخل من بوابة «منسق التطوع» بالبريد أو الجوال."}
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">اسم المنسق {isAssign ? "(اختياري — يُحدَّث إن كُتب)" : "*"}</label>
          <input data-testid="coord-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">البريد الإلكتروني (للدخول) {isAssign ? "*" : "(لا يتغير)"}</label>
          <input data-testid={isAssign ? "coord-email-input" : "coord-email-view"} value={form.email || ""} disabled={!isAssign}
            onChange={(e) => setForm({ ...form, email: e.target.value })} className={`${inputCls} ${isAssign ? "" : "opacity-60"}`} dir="ltr" />
        </div>
        <div>
          <label className="text-xs font-bold text-mutext block mb-1.5">جوال المنسق (للدخول)</label>
          <input data-testid="coord-phone-input" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={inputCls} dir="ltr" />
        </div>
        {!isAssign && (
          <div>
            <label className="text-xs font-bold text-mutext block mb-1.5">كلمة مرور جديدة (اتركها فارغة للإبقاء على الحالية)</label>
            <input data-testid="coord-password-input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} dir="ltr" />
          </div>
        )}
        <button data-testid="coord-save-btn" onClick={onSave} disabled={busy} className={`${btnPrimary} w-full justify-center`}>
          {busy ? "جارٍ الحفظ …" : isAssign ? "حفظ وربط بالمدرسة" : "حفظ بيانات المنسق"}
        </button>
      </div>
    </Modal>
  );
}
